export default __webpack_public_path__ + "locales/el-GR/JavascriptSdk.json?hash=1c9862a04aaaec70e8bcbe1e11c89c67";